import { useState, useCallback, useMemo } from 'react';

const useStepper = ({ steps = [], initialStep = 0 }) => {
  const [activeStep, setActiveStep] = useState(initialStep);

  const activeStepName = useMemo(() => {
    return steps[activeStep] || null;
  }, [steps, activeStep]);

  const handleNext = useCallback(() => {
    setActiveStep((prevStep) => {
      if (prevStep >= steps.length - 1) {
        return prevStep;
      }
      return prevStep + 1;
    });
  }, [steps.length]);

  const handlePrevious = useCallback(() => {
    setActiveStep((prevStep) => {
      if (prevStep <= 0) {
        return prevStep;
      }
      return prevStep - 1;
    });
  }, []);

  const reset = useCallback(() => {
    setActiveStep(initialStep);
  }, [initialStep]);

  return {
    steps,
    activeStep,
    activeStepName,
    handleNext,
    handlePrevious,
    reset,
    isFirstStep: activeStep === 0,
    isLastStep: activeStep === steps.length - 1,
  };
};

export default useStepper;
